const selectSubmit = (el) => {
    const closestForm = el.closest('form');

    el.addEventListener('change', () => closestForm.submit());
};

export default selectSubmit;
